import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../../common/models';
import { AllocationViewFilterProfileModel } from '../../models';
import {
  AllocationViewFilterProfileListInitialState,
  AllocationViewFilterProfileListLoad,
} from './allocation-view-filter-profile-list.actions';
import { AllocationViewFilterProfileListState } from './allocation-view-filter-profile-list.state';

@Injectable({ providedIn: 'root' })
export class AllocationViewFilterProfileListFacade implements LoadDataFacade, SetInitialStateFacade {
  profileList$: Observable<AllocationViewFilterProfileModel[]> = this.store.select(
    AllocationViewFilterProfileListState.getItems,
  );
  loaded$: Observable<boolean> = this.store.select(AllocationViewFilterProfileListState.getLoaded);

  constructor(private store: Store) {}

  loadAll(): void {
    this.store.dispatch(new AllocationViewFilterProfileListLoad());
  }

  setInitialState(): void {
    this.store.dispatch(new AllocationViewFilterProfileListInitialState());
  }
}
